import React from "react";
import HomeBanner from "../components/HomeBanner";
import ServicesTeaser from "../components/home/ServicesTeaser";
import TestimonialsSlider from "../components/home/TestimonialSlider";
import CtaBand from "../components/home/CtaBand";
const Home = () => {
  return (
    <>
      <HomeBanner />
        <ServicesTeaser />
        <TestimonialsSlider/>
        <CtaBand />
    </>
  );
};

export default Home;
